import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { DrillNavModel } from './navModel';
import { trigger, style, transition, state, animate, keyframes } from "@angular/animations";

@Component({
  selector: 'ngx-cm-drilldown-nav',
  templateUrl: 'drilldown-nav.component.html',
  styleUrls: ['drilldown-nav.component.scss'],
  animations: [trigger('menu', [
    state("in", style({ opacity: 1 })),
    transition("* => in", [
      style({ opacity: 0, transform: "translateX(100px)", visibility: "hidden" }),
      animate("100ms ease-in", style({ opacity: 1, transform: "translateX(0)", visibility: "visible" }))
    ]),
    state("out", style({ opacity: 1 })),
    transition("* => out", [
      style({ opacity: 0, transform: "translateX(-100px)", visibility: "hidden" }),
      animate("100ms ease-out", style({ opacity: 1, transform: "translateX(0)", visibility: "visible" }))
    ]),
  ])]
})
export class DrilldownNavComponent implements OnInit {
  @Input("Data") nav: Array<DrillNavModel>;

  public activeNav: Array<DrillNavModel> = this.nav;
  public parent: DrillNavModel = null;
  public state: string = "in";

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.nav.currentValue != changes.nav.previousValue) {
      this.activeNav = this.nav;
    }
  }

  drillDown(nav: DrillNavModel) {
    if (nav.click) nav.click();
    if (!nav.path && nav.children && nav.children.length > 0) {
      this.state = "in";
      this.parent = nav;
      this.activeNav = nav.children;
    }
  }

  drillUp() {
    if (this.parent && this.parent.root) {
      this.state = "out";
      this.activeNav = this.nav;
      this.parent = null;
    } else if (this.parent && !this.parent.root) {
      this.parent = this.findParent(this.nav, this.parent);
      this.state = "out";
      this.activeNav = this.parent.children;
    }
  }

  findParent(nav: Array<DrillNavModel>, child: DrillNavModel) {
    for (let i = 0; i < nav.length; i++) {
      if (nav[i].id == child.parent) {
        return nav[i];
      } else {
        if (nav[i].children && nav[i].children.length > 0) {
          this.findParent(nav[i].children, child);
        }
      }
    }
  }
}
